import AuthenticationRepository from './AuthenticationRepository.js'

export default class ScreensetRepository extends AuthenticationRepository {
  constructor({screensets, screensetValueObjectsFactory}) {
    super()

    this._screensets = screensets
    this._screensetValueObjectsFactory = screensetValueObjectsFactory
  }

  _getRequestedScreenset(value) {
    switch (value) {
      case 'f':
        return this._screensets.forgot
      case 'l':
        return this._screensets.login
      case 'r':
        return this._screensets.register
      default:
        return this._screensets.default
    }
  }

  _getScreensetString({urlVars}) {
    if (urlVars.pwrt) {
      return this._screensets.reset
    }
    return urlVars.p ? this._getRequestedScreenset(urlVars.p) : this._screensets.default
  }

  async getScreenset({urlVars}) {
    const screenset = this._getScreensetString({urlVars})
    return this._screensetValueObjectsFactory({screenset})
  }
}
